var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"Not found","back-link":"Back"}}),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("Sorry")]),_c('p',[_vm._v("Requested content not found.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }